<template>
    <div></div>
</template>

<script>
export default {
    props: ['query'],
    
    data: () => ({
        loading: false
    }),

    created() {
        this.findProducts();
    },

    mounted() {},

    computed: {},

    methods: {
        /**
         * @see https://developer.ebay.com/Devzone/shopping/docs/Concepts/ShoppingAPI_FormatOverview.html
         */
        findProducts() {
            this.loading = true;
            
            axios.get('https://open.api.ebay.com/shopping', {
                params: {
                    callname         : 'FindProducts',
                    QueryKeywords    : this.query
                    // responseencoding : 'JSON',
                    // appid            : '',
                    // siteid           : 0,
                    // version          : 1119
                },
                headers: {
                    'X-EBAY-API-SITE-ID'               : 0,
                    'X-EBAY-API-APP-ID'                : process.env.MIX_EBAY_CLIENT_ID,
                    'X-EBAY-API-TRACKING-ID'           : process.env.MIX_EBAY_AFFILIATE_ID,
                    'X-EBAY-API-TRACKING-PARTNER-CODE' : 9,
                    'X-EBAY-API-REQUEST-ENCODING'      : 'JSON',
                    'X-EBAY-API-VERSION'               : 1157
                    // 'X-EBAY-API-AFFILIATE-USER-ID': clickId
                }
            })
                .then(response => {
                    this.items = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
